import type { InputHTMLAttributes } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  error?: string;
};

export function Input({ label, error, ...rest }: Props) {
  return (
    <div style={{ marginBottom: '12px' }}>
      <small>
        <label htmlFor={rest.id} className="form-label text-muted ">
          {label}
        </label>
      </small>
      <input
        autoComplete="off"
        className="form-control"
        minLength={3}
        maxLength={100}
        {...rest}
      />
      <div style={{ height: '10px' }}>
        {error && <small className="text-danger">{error}</small>}
      </div>
    </div>
  );
}
